import { type AcquireBookPictures } from "@/types/acquirebook";
import { type AcquiredProperty } from "../types";
import { format, parseISO } from "date-fns";
import {
  formatDocumentDateForExport,
  formatDocumentStatusForExport,
} from "./documentPresentation";

export const DOCUMENT_COLUMNS: Array<[AcquireBookPictures, string]> = [
  ["ZENBUJIKO", "全部事項"],
  ["SHOYUSHAJIKO", "所有者事項"],
  ["DENSHIKOZU", "電子公図"],
  ["CHISEKISOKURYOZU", "地積測量図"],
  ["CHIEKIKENZUMEN", "地役権図面"],
  ["TATEMONOZUMEN", "建物図面"],
];
export const REAL_ESTATE_LABELS: Record<string, string> = {
  LAND: "土地",
  BUILDING: "建物",
  CONDOMINIUM: "区分建物",
};

export const canReacquire = (row: AcquiredProperty): boolean =>
  row.documents.some(
    (document) => document.status === "SUCCEEDED" && Boolean(document.uri)
  );

export const getCompanyNames = (row: AcquiredProperty): string =>
  [
    ...new Set(
      row.documents.map((document) => document.companyName).filter(Boolean)
    ),
  ].join("\n");

/** スマホでもPCと同じ列・日付・書類の状態を出力する。 */
export const getPropertyExportRows = (
  rows: AcquiredProperty[],
  includeCompany: boolean
): string[][] => [
  [
    "識別名",
    "取得依頼日",
    ...(includeCompany ? ["会社名"] : []),
    "種別",
    "都道府県",
    "所在",
    "地番または家屋番号",
    ...DOCUMENT_COLUMNS.flatMap(([, title]) => [title, `${title}取得日`]),
  ],
  ...rows.map((row) => [
    row.identificationName ?? "",
    format(parseISO(row.requestedAt), "yyyy/MM/dd HH:mm"),
    ...(includeCompany ? [getCompanyNames(row)] : []),
    REAL_ESTATE_LABELS[row.realEstateType] ?? row.realEstateType,
    row.prefectureName,
    row.location,
    row.chibanKaokuNumber,
    ...DOCUMENT_COLUMNS.flatMap(([type]) => {
      const documents = row.documents.filter(
        (document) => document.pictureType === type
      );
      return [
        documents.map(formatDocumentStatusForExport).join("\n"),
        documents.map(formatDocumentDateForExport).join("\n"),
      ];
    }),
  ]),
];
